import { useEffect, useRef } from 'react';

const useQueryError = (error, handler) => {
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    if (error) handlerRef.current();
  }, [error]);
};

export default useQueryError;
